<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <!-- <div
        class="iconfont"
        :style="{
          backgroundImage: `url(
            ${item.url === $route.path ? item.icon1 : item.icon2}
          )`
        }"
      ></div> -->
      <img
        :src="item.url === $route.path ? item.icon1 : item.icon2"
        class="icon-image"
      />
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首頁",
          icon1: require("@/assets/moblie/images/home-selected.png"),
          icon2: require("@/assets/moblie/images/home-not-selected.png"),
          url: "/"
        } /*
        {
          name: "科普知识",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/news_list"
        },*/,
        {
          name: "購物車",
          icon1: require("@/assets/moblie/images/cart-selected.png"),
          icon2: require("@/assets/moblie/images/cart-not-selected.png"),
          url: "/cart"
        },
        {
          name: "我的",
          icon1: require("@/assets/moblie/images/mine-selected.png"),
          icon2: require("@/assets/moblie/images/mine-not-selected.png"),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
